import CreateNewPassword from "../Pages/Authentication/CreateNewPassword/CreateNewPassword";
import ForgotPassword from "../Pages/Authentication/ForgotPassword/ForgotPassword";
import ForgotPasswordOtp from "../Pages/Authentication/ForgotPassword/ForgotPasswordOTP";
import SignIn from "../Pages/Authentication/SignIn/SignIn";
import SignUp from "../Pages/Authentication/SignUp/SignUp";
import SignupOtp from "../Pages/Authentication/SignUp/SignupOtp";
import TransactableOffer from "../Pages/Other/TransactableOffer";

const OG_DESCRIPTION =
  "Access hundreds of exclusive deals and discounts from your favorite local businesses. Start saving today!";

const OG_DESCRIPTION_RESOURCES =
  "How to use guide, Free Resources, shop local, buy local, hyper local marketplace, community marketplace";

const OG_IMAGE =
  "https://customer.communityx.digital/static/media/ogImage.ffae56f6b37405a0dcb6.png";

const PublicPages = [
  {
    path: "/",
    component: SignIn,
    pageTitle: "CommunityX Digital| Customer Login",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
  {
    path: "/signin",
    component: SignIn,
    pageTitle: "CommunityX Digital| Customer Login",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
  {
    path: "/signup",
    component: SignUp,
    pageTitle: "CommunityX Digital| Customer Sign Up",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
  {
    path: "/signup/otp",
    component: SignupOtp,
    pageTitle: "CommunityX Digital| Verify OTP",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    pageTitle: "CommunityX Digital| Forgot Password",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
  {
    path: "/forgot-password/otp",
    component: ForgotPasswordOtp,
    pageTitle: "CommunityX Digital| Forgot Password OTP",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
  {
    path: "/create-new-password",
    component: CreateNewPassword,
    pageTitle: "CommunityX Digital| Create New Password",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
  {
    path: "/marketplace-offer",
    component: TransactableOffer,
    pageTitle: "CommunityX Digital| Marketplace Offer",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
];

export default PublicPages;
